<template>
  <img v-if="visible" class="magic-ui-img" :src="srcValue" @click="clickHandler" />
</template>
<script lang="ts" setup>
import { reactive, watch, ref } from 'vue';
import { MComponent } from '@tmagic/schema';
import useApp from '@/hooks/useApp';
import useDisplay from '@/hooks/useDisplay';
import initValue from '../initValue';

const props = defineProps<{
  config: MComponent & typeof initValue;
}>();

const app = useApp(props);

const srcValue = ref(props.config.src);
watch(() => props.config.src, (val: string) => {
  srcValue.value = val;
})


const clickHandler = () => {

}
const { visible, show, hide } = useDisplay(props);
// 暴露给编辑器的接口请注册在这里
const exportInterface = reactive({
  value: srcValue,
  show,
  hide,
});

defineExpose(exportInterface);
</script>
